export interface SkuStockLevel {
  skuId: string
  stockLevel: number | null
  warehouseId: string
}

export function getSkuStockLevels(stockLevelDetails: any[], skuIds: string[]): SkuStockLevel[] {
  return stockLevelDetails.flatMap((v) => {
    // For variant-level data, v has skuStockLevels
    if (v.skuStockLevels) {
      return Object.entries(v.skuStockLevels).map(([skuId, stockLevel]) => ({
        skuId,
        stockLevel: stockLevel as number | null,
        warehouseId: v.warehouseId,
      }))
    }
    // For SKU-level data, v represents the stock level for this SKU at this warehouse
    else {
      const skuId = skuIds[0]
      if (!skuId) return []
      return [
        {
          skuId,
          stockLevel: v.closingStock,
          warehouseId: v.warehouseId,
        },
      ]
    }
  })
}
